module.exports = __webpack_public_path__ + "static/media/contact.49c362ea.jpg";